import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listPonencias:[],
  listPonenciasActivas:[],
  ponencia_selected: {}, //seleccionara el objeto de la lista de magistrados
};

export const mutations = {
  GET_PONENCIAS({ context }, ponencias) {
    let ponencias_array = [];
    Object.entries(ponencias).forEach(([key, val]) => ponencias_array.push(val));
    return (state.listPonencias = ponencias_array);
  }
};

export const actions = {
  GET_PONENCIAS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("GET_PONENCIAS", response.data.data.ponencias);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SELECT_PONENCIA({ commit }, data) {
    return (state.ponencia_selected = data);
  },
  SAVE_PONENCIAS({ commit }, ponencia) {
    return new Promise((resolve, reject) => {
      console.log(ponencia);
      commit("SET_LOADING", true);
      ApiService.post(ponencia)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  EDIT_PONENCIA({ commit }, dataPonencia) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.put(dataPonencia)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_PONENCIA({ commit }, ponencia_id) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(ponencia_id)
        .then(response => {
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  }
};

export const getters = {
  getAllPonencias: state => state.listPonencias,
  listPonenciasActivas:(state, getters )=>{
    return getters.listPonencias.filter(ponencia => ponencia.deleted_at == null)
  },
  poneciaSelected: state => state.ponencia_selected

};
